export const BATCH_STATUS_LABELS = {
    pending: 'Pending',
    processing: 'Processing',
    completed: 'Completed'
};

export const BATCH_STATUS_COLORS = {
    pending: '#f59e0b',
    processing: '#3b82f6',
    completed: '#22c55e'
};

export const DELIVERY_STATUS_LABELS = {
    queued: 'Queued',
    processing: 'Processing',
    sent: 'Sent',
    failed: 'Failed',
    retry_pending: 'Retry Pending',
    skipped: 'Skipped',
    invalid_number: 'Invalid Number',
    daily_limit_exceeded: 'Limit Exceeded'
};

export const DELIVERY_STATUS_COLORS = {
    queued: '#94a3b8',
    processing: '#3b82f6',
    sent: '#22c55e',
    failed: '#ef4444',
    retry_pending: '#f59e0b',
    skipped: '#a78bfa',
    invalid_number: '#f97316',
    daily_limit_exceeded: '#ec4899'
};

// ─── Attachment ───────────────────────────────────────────────────────────────

/** Same accept list and size limit as the chat composer (Chat.jsx). */
export const ATTACHMENT_ACCEPT = 'image/*,video/*,audio/*,application/*,.csv,text/csv';
export const ATTACHMENT_MAX_SIZE = 104857600; // 100 MB

export const ATTACHMENT_TYPE_LABELS = {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    document: 'Document'
};

/** Same MIME → message type mapping as the chat composer and the server. */
export const getAttachmentType = (mimetype = '') => {
    if (mimetype.startsWith('image/')) return 'image';
    if (mimetype.startsWith('video/')) return 'video';
    if (mimetype.startsWith('audio/')) return 'audio';
    return 'document';
};

/** Videos WhatsApp plays as-is; other video formats are converted to MP4 on the server. */
export const isVideoConvertedToMp4 = (file) =>
    getAttachmentType(file.type) === 'video' && !['video/mp4', 'video/3gpp'].includes(file.type);

export const isAllowedAttachment = (file) =>
    ['image/', 'video/', 'audio/', 'application/'].some((prefix) => file.type.startsWith(prefix)) ||
    file.type === 'text/csv' ||
    file.name.toLowerCase().endsWith('.csv');

export const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Trigger a CSV download from a raw CSV string.
 */
export const downloadCSVString = (csvString, fileName) => {
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
